import { createFileRoute } from "@tanstack/react-router";
import { SeriesEpisodesPage } from "@/modules/SeriesDetails";

export const Route = createFileRoute("/_default/series/$series/episodes")({
  component: SeriesEpisodesPage,
});
